"use strict";
exports.__esModule = true;
exports.QuoteDisplayStyle = void 0;
var QuoteDisplayStyle;
(function (QuoteDisplayStyle) {
    QuoteDisplayStyle["DEFAULT"] = "default";
    QuoteDisplayStyle["BUBBLE"] = "bubble";
})(QuoteDisplayStyle = exports.QuoteDisplayStyle || (exports.QuoteDisplayStyle = {}));
//# sourceMappingURL=quote-slice.js.map